import { getDecimalFormat } from "../../helpers/getNumberFormats";

export const configTable = [
  {
    Header: "Fecha",
    accessor: "date",
    filterable: true,
    filterMethod: (filter, row) =>
      row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Unidad",
    accessor: "unit",
    filterable: true,
    filterMethod: (filter, row) =>
      row.unit.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    id: "capacity",
    Header: "Capacidad",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.capacity),
    filterMethod: (filter, row) =>
      String(row.capacity)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Lectura inicial",
    id: "readInitial",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.readInitial),
    filterMethod: (filter, row) =>
      String(row.readInitial)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Lectura final",
    id: "readFinal",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.readFinal),
    filterMethod: (filter, row) =>
      String(row.readFinal)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Diferencia de lecturas",
    id: "readDiff",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.readDiff),
    filterMethod: (filter, row) =>
      String(row.readDiff)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salio",
    id: "rotogaugeInitial",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.rotogaugeInitial),
    filterMethod: (filter, row) =>
      String(row.rotogaugeInitial)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Regreso",
    id: "rotogaugeFinal",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.rotogaugeFinal),
    filterMethod: (filter, row) =>
      String(row.rotogaugeFinal)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Diferencia porcentaje",
    id: "rotogaugeDiff",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.rotogaugeDiff),
    filterMethod: (filter, row) =>
      String(row.rotogaugeDiff)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
];

export const modalsConfig = {
  message: "message",
};

export const configTableAcumulated = [
  {
    Header: "Unidad",
    accessor: "unit",
    filterable: true,
    filterMethod: (filter, row) =>
      row.unit.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    id: "capacity",
    Header: "Capacidad",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.capacity),
    filterMethod: (filter, row) =>
      String(row.capacity)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Diferencia Acumulada",
    id: "diffRead",
    filterable: true,
    accessor: (data) => getDecimalFormat(data.diffRead),
    filterMethod: (filter, row) =>
      String(row.diff)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
  {
    Header: "Porcentaje Acumulado",
    id: "percentage",
    filterable: true,
    accessor: (data) => data.percentage,
    filterMethod: (filter, row) =>
      String(row.percentage)
        .toLowerCase()
        .includes(filter.value.toLowerCase()),
  },
];
